/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { DeleteInvestigationMaintainFileRequest } from '../models';
import { DeleteInvestigatorWorkingPaperRequest } from '../models';
import { DeleteOverdrawnLedgerRequest } from '../models';
import { FileRequest } from '../models';
import { FileStreamResultResponse } from '../models';
import { InvestigationAccountingDetailIEnumerableResponse } from '../models';
import { InvestigationAccountingDetailResponse } from '../models';
import { InvestigationBreachIEnumerableResponse } from '../models';
import { InvestigationDetailResponse } from '../models';
import { InvestigationFilter } from '../models';
import { InvestigationIEnumerableResponse } from '../models';
import { InvestigationMaintainFileIEnumerableResponse } from '../models';
import { InvestigationMaintainFileRequest } from '../models';
import { InvestigationOverdrawnLedgerIEnumerableResponse } from '../models';
import { InvestigationOverdrawnRequest } from '../models';
import { InvestigationPameterRequest } from '../models';
import { InvestigationParameterResponse } from '../models';
import { InvestigationQuestionnaireResponse } from '../models';
import { InvestigationResponse } from '../models';
import { InvestigationStatsResponse } from '../models';
import { InvestigatorWorkingPaperFileStreamRequest } from '../models';
import { InvestigatorWorkingPaperIEnumerableResponse } from '../models';
import { InvestigatorWorkingPaperRequest } from '../models';
import { PrincipalInformationRequest } from '../models';
import { SectionGroupRequest } from '../models';
import { SectionRequest } from '../models';
/**
 * InvestigationApi - axios parameter creator
 * @export
 */
export const InvestigationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteInvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigationMaintainFilePost: async (body?: DeleteInvestigationMaintainFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/DeleteInvestigationMaintainFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteOverdrawnLedgerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost: async (body?: DeleteOverdrawnLedgerRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/DeleteInvestigationOverdrawnLedger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {DeleteInvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost: async (investigationId: number, body?: DeleteInvestigatorWorkingPaperRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/DeleteInvestigatorWorkingPaper/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Investigation
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationFinalizeInvestigationInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationFinalizeInvestigationInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/FinalizeInvestigation/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost: async (investigationId: number, body?: InvestigatorWorkingPaperFileStreamRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/GetFileStreamByInvestigatorWorkingPaperId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationAccountingAppsById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationAccountingDetailsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationBreaches
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationBreachesById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationDetailsById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationMaintainFiles
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationMaintainFiles/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationOverdrawnLedgers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationOverdrawnLedgersByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationParameter
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationParametersInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationParametersInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationParameters/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigationQuestionnaire
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationWithQuestionnaireById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Investigations
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigationsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigatorWorkingPaperFileStream/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetInvestigatorWorkingPapersByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/Investigation/GetIwpsByInvestigationId/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns My InvestigationStats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetMyInvestigationStatsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetMyInvestigationStats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns My Investigations
         * @param {InvestigationFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetMyInvestigationsPost: async (body?: InvestigationFilter, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/GetMyInvestigations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationPauseSyncInvestigationInvestigationIdPut: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationPauseSyncInvestigationInvestigationIdPut.');
            }
            const localVarPath = `/api/v2/Investigation/PauseSyncInvestigation/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationResumeSyncInvestigationInvestigationIdPut: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationResumeSyncInvestigationInvestigationIdPut.');
            }
            const localVarPath = `/api/v2/Investigation/ResumeSyncInvestigation/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost: async (investigationId: number, body?: InvestigationMaintainFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveInvestigationMaintainFile/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost: async (investigationId: number, body?: InvestigationOverdrawnRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveInvestigationOverdrawnLedger/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value if Investigation Parameters is saved
         * @param {InvestigationPameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationParametersPost: async (body?: InvestigationPameterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/SaveInvestigationParameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost: async (investigationId: number, body?: FileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveInvestigatorWorkingPaperFile/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost: async (investigationId: number, body?: InvestigatorWorkingPaperRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveInvestigatorWorkingPaper/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value if Principal Information is saved
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSavePrincipalInformationPost: async (body?: PrincipalInformationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Investigation/SavePrincipalInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value if Section is saved
         * @param {number} investigationId 
         * @param {SectionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveQuestionSectionInvestigationIdPost: async (investigationId: number, body?: SectionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveQuestionSectionInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveQuestionSection/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value if SectionGroup is saved
         * @param {number} investigationId 
         * @param {SectionGroupRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost: async (investigationId: number, body?: SectionGroupRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/Investigation/SaveSectionGroupOverview/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestigationApi - functional programming interface
 * @export
 */
export const InvestigationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteInvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationDeleteInvestigationMaintainFilePost(body?: DeleteInvestigationMaintainFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationDeleteInvestigationMaintainFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteOverdrawnLedgerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body?: DeleteOverdrawnLedgerRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {DeleteInvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: DeleteInvestigatorWorkingPaperRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Investigation
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperFileStreamRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAccountingDetailResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationAccountingDetailIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationBreaches
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationBreachIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationDetailResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationMaintainFiles
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationMaintainFileIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationOverdrawnLedgers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationOverdrawnLedgerIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationParameter
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationParameterResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigationQuestionnaire
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationQuestionnaireResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Investigations
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStreamResultResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns My InvestigationStats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetMyInvestigationStatsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationStatsResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetMyInvestigationStatsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns My Investigations
         * @param {InvestigationFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationGetMyInvestigationsPost(body?: InvestigationFilter, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationGetMyInvestigationsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId: number, body?: InvestigationMaintainFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId: number, body?: InvestigationOverdrawnRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value if Investigation Parameters is saved
         * @param {InvestigationPameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigationParametersPost(body?: InvestigationPameterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigationParametersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId: number, body?: FileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value if Principal Information is saved
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSavePrincipalInformationPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value if Section is saved
         * @param {number} investigationId 
         * @param {SectionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId: number, body?: SectionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value if SectionGroup is saved
         * @param {number} investigationId 
         * @param {SectionGroupRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId: number, body?: SectionGroupRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await InvestigationApiAxiosParamCreator(configuration).apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InvestigationApi - factory interface
 * @export
 */
export const InvestigationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteInvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigationMaintainFilePost(body?: DeleteInvestigationMaintainFileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationDeleteInvestigationMaintainFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {DeleteOverdrawnLedgerRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body?: DeleteOverdrawnLedgerRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {DeleteInvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: DeleteInvestigatorWorkingPaperRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Investigation
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperFileStreamRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperFileStreamRequest, options?: any): AxiosPromise<FileStreamResultResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationAccountingDetailResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationAccountingDetails
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationAccountingDetailIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationBreaches
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationBreachIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationDetails
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationDetailResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationMaintainFiles
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationMaintainFileIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationOverdrawnLedgers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationOverdrawnLedgerIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationParameter
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationParameterResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigationQuestionnaire
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigationQuestionnaireResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Investigations
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<InvestigationIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPaper FileStream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<FileStreamResultResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns InvestigatorWorkingPapers
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns My InvestigationStats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetMyInvestigationStatsGet(options?: any): AxiosPromise<InvestigationStatsResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetMyInvestigationStatsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns My Investigations
         * @param {InvestigationFilter} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationGetMyInvestigationsPost(body?: InvestigationFilter, options?: any): AxiosPromise<InvestigationIEnumerableResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationGetMyInvestigationsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId: number, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationMaintainFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId: number, body?: InvestigationMaintainFileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {InvestigationOverdrawnRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId: number, body?: InvestigationOverdrawnRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value if Investigation Parameters is saved
         * @param {InvestigationPameterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigationParametersPost(body?: InvestigationPameterRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigationParametersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {FileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId: number, body?: FileRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {number} investigationId 
         * @param {InvestigatorWorkingPaperRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value if Principal Information is saved
         * @param {PrincipalInformationRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSavePrincipalInformationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value if Section is saved
         * @param {number} investigationId 
         * @param {SectionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId: number, body?: SectionRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value if SectionGroup is saved
         * @param {number} investigationId 
         * @param {SectionGroupRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId: number, body?: SectionGroupRequest, options?: any): AxiosPromise<BooleanResponse> {
            return InvestigationApiFp(configuration).apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestigationApi - object-oriented interface
 * @export
 * @class InvestigationApi
 * @extends {BaseAPI}
 */
export class InvestigationApi extends BaseAPI {
    /**
     * 
     * @summary Returns boolean
     * @param {DeleteInvestigationMaintainFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationDeleteInvestigationMaintainFilePost(body?: DeleteInvestigationMaintainFileRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationDeleteInvestigationMaintainFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {DeleteOverdrawnLedgerRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body?: DeleteOverdrawnLedgerRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationDeleteInvestigationOverdrawnLedgerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {number} investigationId 
     * @param {DeleteInvestigatorWorkingPaperRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: DeleteInvestigatorWorkingPaperRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationDeleteInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Investigation
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationFinalizeInvestigationInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigatorWorkingPaper FileStream
     * @param {number} investigationId 
     * @param {InvestigatorWorkingPaperFileStreamRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperFileStreamRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetFileStreamByInvestigatorWorkingPaperIdInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationAccountingDetails
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationAccountingAppsByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationAccountingDetails
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationBreaches
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationBreachesByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationDetails
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationDetailsByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationMaintainFiles
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationMaintainFilesInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationOverdrawnLedgers
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationOverdrawnLedgersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationParameter
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationParametersInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigationQuestionnaire
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationWithQuestionnaireByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Investigations
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigationsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigatorWorkingPaper FileStream
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigatorWorkingPaperFileStreamInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigatorWorkingPapers
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetInvestigatorWorkingPapersByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns InvestigatorWorkingPapers
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetIwpsByInvestigationIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns My InvestigationStats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetMyInvestigationStatsGet(options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetMyInvestigationStatsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns My Investigations
     * @param {InvestigationFilter} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationGetMyInvestigationsPost(body?: InvestigationFilter, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationGetMyInvestigationsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationPauseSyncInvestigationInvestigationIdPut(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId: number, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationResumeSyncInvestigationInvestigationIdPut(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {InvestigationMaintainFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId: number, body?: InvestigationMaintainFileRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigationMaintainFileInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {InvestigationOverdrawnRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId: number, body?: InvestigationOverdrawnRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigationOverdrawnLedgerInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value if Investigation Parameters is saved
     * @param {InvestigationPameterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigationParametersPost(body?: InvestigationPameterRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigationParametersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {number} investigationId 
     * @param {FileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId: number, body?: FileRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigatorWorkingPaperFileInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {number} investigationId 
     * @param {InvestigatorWorkingPaperRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId: number, body?: InvestigatorWorkingPaperRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveInvestigatorWorkingPaperInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value if Principal Information is saved
     * @param {PrincipalInformationRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSavePrincipalInformationPost(body?: PrincipalInformationRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSavePrincipalInformationPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value if Section is saved
     * @param {number} investigationId 
     * @param {SectionRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId: number, body?: SectionRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveQuestionSectionInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value if SectionGroup is saved
     * @param {number} investigationId 
     * @param {SectionGroupRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigationApi
     */
    public apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId: number, body?: SectionGroupRequest, options?: any) {
        return InvestigationApiFp(this.configuration).apiV2InvestigationSaveSectionGroupOverviewInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
